module.exports = __webpack_public_path__ + "static/media/hcfamemalogo.df962e87.png";